<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Geographical type</label>
          <el-select
              v-model="localFilters.geographicalType.value"
              placeholder="Select values"
              @change="localFilters.geographicalValue.value = ''" collapse-tags
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in geoTypes"
                  :key="value.value" :label="value.name" :value="value.value">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Value</label>
          <el-select
              v-model="localFilters.geographicalValue.value"
              placeholder="Select values"
              :disabled="!localFilters.geographicalType.value" collapse-tags
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getCicsTagValues(localFilters.geographicalType.value)"
                  :key="value" :label="value" :value="value">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Gender</label>
          <el-select
              v-model="localFilters.gender.value"
              placeholder="Select values" collapse-tags
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getCicsTagValues('Gender')"
                  :key="value" :label="value" :value="value">
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Age</label>
          <div class="slider-wrapper">
            <el-slider
                v-if="Object.keys(ageInput).length"
                v-model="ageInput.value"
                range
                :min="ageInput.min"
                :max="ageInput.max"
                :marks="createSliderBreakpoints(ageInput.min, ageInput.max, 5)"
                @change="parseAge()"
            >
            </el-slider>
          </div>
        </div>
        <!--        <div class="d-flex justify-content-center align-items-center w-100"-->
        <!--             style="margin-top: -5px; margin-left: -45px;">-->
        <!--          <el-checkbox class="ml-5" v-model="ageInput.includeMissing">Include studies with no age</el-checkbox>-->
        <!--        </div>-->
      </div>
      <div class="col-12 d-flex flex-column align-items-center" style="margin-top: 17px">
        <div class="input-wrapper">
          <label>Question</label>
          <el-input placeholder="Enter question, part of a question, or question keywords"
                    v-model="localFilters.question.value"
                    clearable></el-input>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import utilsFunctions from '../../helpers/utilsFunctions'

export default {
  name: 'CicsForm',
  emits: ['update:filters'],
  props: {
    filters: Object,
    geoTypes: Array,
    getCicsTagValues: Function
  },
  data () {
    return {
      localFilters: _.cloneDeep(this.filters),
      ageInput: {
        min: 0,
        max: 99,
        value: [0, 99],
        marks: {
          0: '0',
          99: '99'
        },
        includeMissing: true
      },
      createSliderBreakpoints: utilsFunctions.createSliderBreakpoints
    }
  },
  methods: {
    parseAge () {
      this.localFilters.startAge.value = this.ageInput.value[0]
      this.localFilters.endAge.value = this.ageInput.value[1]
    },
    clearAgeInput () {
      this.$set(this.ageInput, 'value', [this.ageInput.min, this.ageInput.max])
      this.localFilters.startAge.value = this.ageInput.min
      this.localFilters.endAge.value = this.ageInput.max
    }
  },
  watch: {
    filters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localFilters)) {
          this.localFilters = _.cloneDeep(value)
        }
      }
    },
    localFilters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.filters)) {
          this.$emit('update:filters', _.cloneDeep(value))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0;
}

.slider-wrapper {
  padding: 0 10px;
}
</style>
